<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="mobile-responsive">
  @if (!isFormSend) {
    <div class="card col-lg-3 col-11 mx-auto">
      <div class="card-body">
        <h4>Passwort ändern</h4>
        <p>Geben Sie Ihr neues Passwort ein. Achten Sie darauf, dass es mindestens 10 Zeichen lang ist und mindestens 1 Sonderzeichen (?! ….) enthält.
        Bestätigen Sie Ihr neues Passwort, indem Sie es erneut eingeben.</p>
        <form [formGroup]="changePasswordForm" style="margin-top: 1.75rem" (ngSubmit)="onSubmit()">
          <label class="form-label w-100 mt-3">
            Neues Passwort<span class="required">*</span>
            <div class="position-relative">
              <input noTrim [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" class="form-control" placeholder="•••••••••••••"
               [style]="((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ) || changePasswordForm.get('password')!.hasError('required')
                || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))
               && changePasswordForm.get('password')!.touched ? 'padding-left: 2.25rem;' : '' "
               [ngClass]="((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) || changePasswordForm.get('password')!.hasError('required')
                || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))  
               && changePasswordForm.get('password')!.touched ? 'invalid' : '' " minlength="10">
              <i class="visibility-icon my-auto"
                [class.icon-visibility-on]="!isPasswordVisible"
                [class.icon-visibility-off]="isPasswordVisible"
                (click)="isPasswordVisible = !isPasswordVisible">
              </i>
              @if (((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) || changePasswordForm.get('password')!.hasError('required')
                || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))
                && (changePasswordForm.get('password')!.touched || changePasswordForm.get('passwordConfirm')!.touched)) {
                <i class="icon-cancel"></i>
              }
            </div>
            @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched
              && !changePasswordForm.get('password')!.hasError('minlength') && !changePasswordForm.get('password')!.hasError('minlength')
              && !changePasswordForm.get('password')!.hasError('requiresSpecialChars')) {
              <span style="color: red; font-size: 12px;font-weight: 600;">Die Passwörter sollten gleich sein</span>
            }
            @if (changePasswordForm.get('password')!.hasError('required') && changePasswordForm.get('password')!.touched) {
              <span style="color: red; font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
            }
            @if (changePasswordForm.get('password')!.hasError('minlength') && changePasswordForm.get('password')!.touched) {
              <span style="color: red; font-size: 12px; font-weight: 600;">Ein Passwort muss aus mindestens zehn Zeichen bestehen.</span>
            }
            @if (changePasswordForm.get('password')!.hasError('requiresSpecialChars') && changePasswordForm.get('password')!.touched && !changePasswordForm.get('password')!.hasError('minlength')) {
              <span style="color: red; font-size: 12px; font-weight: 600;" class="mb-3">Das Passwort sollte mindestens ein Sonderzeichen enthalten.</span>
            }
          </label>
          <label class="form-label w-100 mt-3">
            Passwort bestätigen<span class="required">*</span>
            <div class="position-relative">
              <input noTrim [type]="isPasswordConfirmVisible ? 'text' : 'password'" formControlName="passwordConfirm" class="form-control" placeholder="•••••••••••••"
                [style]=" changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ? 'padding-left: 2.25rem;' : '' "
                [ngClass]="changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ? 'invalid' : '' ">
              @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) {
                <i class="icon-cancel"></i>
              }
              <i class="visibility-icon my-auto"
                [class.icon-visibility-on]="!isPasswordConfirmVisible"
                [class.icon-visibility-off]="isPasswordConfirmVisible"
                (click)="isPasswordConfirmVisible = !isPasswordConfirmVisible">
              </i>
            </div>
            @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) {
              <span style="color: red; font-size: 12px; font-weight: 600;">Die Passwörter sollten gleich sein</span>
            }
          </label>
          <button type="submit" class="btn btn-primary d-block mx-auto submit-button" [disabled]="changePasswordForm.invalid">Neues Passwort speichern</button>
        </form>
      </div>
    </div>
  }
  @if (isFormSend) {
    <div style="margin-top: 8rem;" class="card col-lg-3 col-11 mx-auto">
      <div class="card-body">
        <div class="text-center">
          <span class="icon-check-circle"></span>
          <h4 class="mt-2r">Passwort wurde erfolgreich geändert</h4>
          <small>
            Ihr Passwort wurde erfolgreich geändert. Sie können sich nun mit dem neuen Passwort und Ihrer Emailadresse anmelden.
          </small>
        </div>
        <button type="button" class="btn btn-primary d-block mx-auto submit-button" (click)="GoToLogin()"><span style="padding-left: 8px; padding-right: 8px;">Login</span></button>
      </div>
    </div>
  }
  @if (isFormSend) {
    <div class="text-center mt-md-4 link">
      <span class="link-btn" (click)="GoToLogin()">Zurück zum Login</span>
    </div>
  }
  <div class="text-center link" [ngClass]="{'mt-md-4': !isFormSend}">
    <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span>
    <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum </a>
  </div>

  <ng-template #passwordInfo>
    <div style="font-size: 14px;" class="text-start">Das Passwort muss die folgenden Anforderungen erfüllen:
      <ul>
        <li>Mindestens 10 Zeichen</li>
        <li>Mindestens ein Sonderzeichen wie !&#64;#$%^&*()_+</li>
      </ul>
    </div>
  </ng-template>

